// src/data/articles.js
// 30 статей: slug, title, excerpt, image, content (HTML-разметка допустима)

export const articles = [
    {
      slug: 'metal-processing-basics',
      title: 'Основи сучасної металообробки',
      excerpt: 'Що таке токарні та фрезерні операції, де застосовується ЧПУ і які переваги автоматизації.',
      image: '/images/articles/metal-01.jpg',
      content: `
        <h2>Вступ</h2>
        <p>Металообробка охоплює широкий спектр операцій — від токарної і фрезерної до шліфування, розточування та зубонарізки. 
        Автоматизація (ЧПУ) забезпечує стабільність розмірів і повторюваність.</p>
        <h3>Основні процеси</h3>
        <ul>
          <li>Точіння — отримання обертальних поверхонь</li>
          <li>Фрезерування — плоскі/просторові поверхні</li>
          <li>Розточка — точні внутрішні отвори</li>
        </ul>
        <p>Для складних деталей застосовується комбінування операцій і технологічних пристроїв.</p>
      `
    },
    {
      slug: 'gear-cutting-overview',
      title: 'Зубонарізка: зовнішній та внутрішній зуб',
      excerpt: 'Модулі, профіль зуба, особливості обробки великих коліс.',
      image: '/images/articles/metal-02.jpg',
      content: `
        <p>Зубонарізка включає довбання, нарізання черв'ячними фрезами та шевінгування. 
        Правильний підбір інструменту і режимів дозволяє досягти потрібного класу точності.</p>
      `
    },
    {
      slug: 'welding-hardfacing',
      title: 'Зварка і наплавка зносостійкими матеріалами',
      excerpt: 'Відновлення посадок і кромок, підвищення ресурсу вузлів.',
      image: '/images/articles/metal-03.jpg',
      content: `
        <p>Наплавка карбідовмісними матеріалами відновлює геометрію і підвищує зносостійкість контактних поверхонь. 
        Важливо дотримуватись режимів підігріву та охолодження для уникнення тріщин.</p>
      `
    },
    {
      slug: 'heat-treatment',
      title: 'Термообробка металів: гарт і відпуск',
      excerpt: 'Керування структурою металу для досягнення заданої твердості.',
      image: '/images/articles/metal-04.jpg',
      content: `
        <p>Комбінації гарту й відпуску дозволяють отримати оптимальне поєднання твердості та в'язкості, 
        що критично для шестерень, валів та інструментів.</p>
      `
    },
    {
      slug: 'laser-cutting-sheet',
      title: 'Лазерна різка листового металу',
      excerpt: 'Точність, чиста кромка, висока продуктивність.',
      image: '/images/articles/metal-05.jpg',
      content: `
        <p>Лазерне різання оптимальне для тонколистових матеріалів, складних контурів і серійного виробництва. 
        Важливі налаштування газу, потужності та швидкості.</p>
      `
    },
    {
      slug: 'bending-basics',
      title: 'Гнуття листового металу',
      excerpt: 'Точність кутів, компенсація пружного повернення.',
      image: '/images/articles/metal-06.jpg',
      content: `
        <p>Розрахунок розгортки та правильний вибір пуансона/матриці зменшують похибки й забезпечують повторюваність.</p>
      `
    },
    {
      slug: 'powder-coating',
      title: 'Порошкове фарбування: підготовка і контроль',
      excerpt: 'Адгезія, товщина покриття, полімеризація.',
      image: '/images/articles/metal-07.jpg',
      content: `
        <p>Якість покриття залежить від очищення, фосфатування та режиму печі. 
        Контроль товщини гарантує заявлену корозійну стійкість.</p>
      `
    },
    {
      slug: 'small-batch-manufacturing',
      title: 'Малосерійне виготовлення для машинобудування',
      excerpt: 'Гнучка оснастка і уніфікація заготовок скорочують терміни.',
      image: '/images/articles/metal-08.jpg',
      content: `
        <p>Швидка переналадка і продумана технологічність критичні для малих серій і дослідних партій.</p>
      `
    },
    {
      slug: 'furniture-office',
      title: 'Меблі для офісів: ергономіка та акустика',
      excerpt: 'Як робоче місце впливає на продуктивність.',
      image: '/images/articles/fur-01.jpg',
      content: `
        <p>Продумана ергономіка, акустичні панелі та змінні конфігурації підвищують комфорт і ефективність команди.</p>
      `
    },
    {
      slug: 'furniture-home',
      title: 'Домашні меблі: матеріали і довговічність',
      excerpt: 'Дерево, МДФ, шпон чи HPL — що обрати?',
      image: '/images/articles/fur-02.jpg',
      content: `
        <p>Композиція матеріалів дає баланс бюджету й ресурсу. Важлива фурнітура і коректна вологість приміщення.</p>
      `
    },
    {
      slug: 'retail-expo',
      title: 'Retail та виставки: модульні рішення',
      excerpt: 'Швидкий монтаж/демонтаж, мобільність, брендинг.',
      image: '/images/articles/fur-03.jpg',
      content: `
        <p>Модульні системи забезпечують гнучкість експозицій й скорочують час простою.</p>
      `
    },
    {
      slug: 'hpl-intro',
      title: 'HPL-панелі: властивості та сфери застосування',
      excerpt: 'Стільниці, стінові/фасадні системи, санітарні перегородки.',
      image: '/images/articles/hpl-01.jpg',
      content: `
        <p>HPL — міцний і стійкий до зносу матеріал, з великою палітрою кольорів і текстур.</p>
      `
    },
    {
      slug: 'hpl-installation-interior',
      title: 'Монтаж HPL в інтер’єрі',
      excerpt: 'Клейові та приховані системи, компенсаційні шви.',
      image: '/images/articles/hpl-02.jpg',
      content: `
        <p>Ключові аспекти — підготовка основи, температура/вологість, рекомендації виробника клею.</p>
      `
    },
    {
      slug: 'hpl-facade',
      title: 'Фасадні системи з HPL',
      excerpt: 'Підконструкція, кріплення, вітрові та температурні навантаження.',
      image: '/images/articles/hpl-03.jpg',
      content: `
        <p>Проєктування фасадів передбачає розрахунок кріплень, деформаційних швів і правильну вентиляцію.</p>
      `
    },
    // Добавим ещё 15 коротких заметок (итого 30)
    ...Array.from({ length: 15 }).map((_, i) => ({
      slug: `tech-note-${i + 1}`,
      title: `Технічна замітка #${i + 1}`,
      excerpt: 'Короткий огляд прикладного питання виробництва/монтажу.',
      image: `/images/articles/note-${(i % 6) + 1}.jpg`,
      content: `
        <p>Приклад технічної замітки: вибір інструменту, режимів обробки, допуски, просочення, упаковка, логістика.</p>
      `
    }))
  ];
  // 2) Форматтер даты, который использует ArticlesPage.jsx
export function fmtDate(d) {
  try {
    // UA-локаль по умолчанию
    return new Date(d).toLocaleDateString('uk-UA', {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    });
  } catch {
    return d;
  }
}

// 3) Категории — то, чего не хватало.
// Если у статей есть поле "category", соберём уникальные значения.
// Если поля нет — экспортируем пустой массив, чтобы код не падал.

export const CATEGORIES = Array.from(
  new Set(
    (articles || [])
      .map(a => a && a.category)
      .filter(Boolean)
  )
);

// 4) Дополнительно: индекс по slug, если где-то удобно быстрый доступ
export const articlesBySlug = Object.fromEntries(
  (articles || []).map(a => [a.slug, a])
);
  // Утиліта пошуку
  export const findArticleBySlug = (slug) => articles.find(a => a.slug === slug);
